export default () => ({
  staffList: [],
  healthCareTeamList: [],
  categoryList: [],
  statuses: [],
  healthEvents: [],
  filters: {},
  sortBy: 'dueDate',
  sortOrder: 'desc',
  range: null,
  loading: false,
  stopLoad: false,
  currentEvent: undefined,
  followUpData: {
    channelReference: {},
    automaticFollowUp: false,
    fupType: {},
    channelFupId: null
  },
  plannedFollowUps: [],
  hasErrorOnFetching: false
})
